import { useQuery } from '@tanstack/react-query';
import { checkMerchantOrBCAPI } from 'utils/API/Merchant APIs/MerchantApiCalls';
import { QUERY_KEYS } from './QueryKeys';

export const useMerchantCheck = (onModalShow) => {
    const agentid = localStorage.getItem('id');

    return useQuery({
        queryKey: QUERY_KEYS.MERCHANT_CHECK(agentid),
        queryFn: async () => {
            const payloadCheck = { agentid };
            const response = await checkMerchantOrBCAPI(payloadCheck);
            const { isESigned, agentType, isPending } = response?.data || {};
            return {
                agentType,
                isPending,
                isESigned,
                shouldShowModal: agentType === 'Merchant' || isPending || isESigned === false
            };
        },
        staleTime: 60000,
        onSuccess: (data) => {
            if (data?.shouldShowModal) {
                onModalShow(true);
            }
        }
    });
};
